import { dateRequiredSchema } from 'utils/validation/validationHelpers';
import * as Yup from 'yup';

export const schoolDischargeScreeningValidationSchema = Yup.object().shape({
    screening_results: Yup.array()
        .of(
            Yup.object().shape({
                area: Yup.mixed()
                    .required('Area is required'),
                area_description: Yup.string()
                    .required('Description is required')
                    .test('is-not-empty', 'Description cannot be empty', value => {
                        // CKEditor content may have empty tags; strip HTML and validate
                        const stripped = value?.replace(/<[^>]*>/g, '').trim();
                        return !!stripped;
                    }),
            })
        ),
    screening_date: Yup.date()
        .nullable()
        .required('Screening date is required'),
}
);
